import { Text } from '@consta/uikit/Text'

import { typedMemo } from '../helpers'
import { ModalNavItem } from '../ModalNavItem'
import type { ModalErrors, ModalItem } from '../types'
import css from './ModalNavGroup.css'

type ModalNavGroupProps<Item extends ModalItem> = {
  title: string
  activeItem: Item
  items: Item[]
  errors?: ModalErrors[]
  onChoose: (item: Item) => void
}

export const ModalNavGroup = typedMemo(function ModalNavGroup<Item extends ModalItem>({
  title,
  items,
  activeItem,
  errors,
  onChoose,
}: ModalNavGroupProps<Item>) {
  return (
    <div className={css.group}>
      <Text size="xs" view="secondary">
        {title}
      </Text>
      {items.map(item => {
        const id = item.id
        const error = errors?.find(error => error.itemId === id)
        const isActive = activeItem.id === id

        return (
          <ModalNavItem
            key={id}
            item={item}
            error={error}
            isActive={isActive}
            onChoose={onChoose}
          />
        )
      })}
    </div>
  )
})
